import axiosInstance from "../app/axios";

export interface FiltersDepartment {
  searchText?: string | undefined;
  page?: number;
  take?: number;
}

export const getDepartmentsApi = async (filters?: FiltersDepartment) => {
  const { page, take, searchText } = filters || {};
  const result = await axiosInstance.post(
    `department/admin/search?page=${page}&take=${take}`,
    { searchText },
  );
  return result.data;
};

export const createDepartmentApi = async (name: string) => {
  const result = await axiosInstance.post(`department/admin`, {
    name,
  });
  return result.data;
};

export const editDepartmentApi = async (id: string | number, name: string) => {
  const result = await axiosInstance.patch(`department/${id}`, { name });
  return result.data;
};

export const deleteDepartmentApi = async (id: string) => {
  const result = await axiosInstance.delete(`department/admin/${id}`);
  return result.data;
};

export const getDepartmentsByAdminApi = async (adminId?: number) => {
  if (adminId) {
    const result = await axiosInstance.get(`department/admin/${adminId}`, {
      headers: { "x-hide-success": true },
    });
    return result.data;
  }
  const result = await axiosInstance.get("department/admin/token", {
    headers: { "x-hide-success": true },
  });
  return result.data;
};
